<template>
  <div v-if="!isSmWidth" :class="[$style.background, classes]" :style="{ height: height }">
    <SvgSelect
      v-if="hasValidImage"
      :svg="image"
      :width="dimensions.width"
      :height="dimensions.height"
      :aspect-ratio="aspectRatio"
      :svg-props="dimensions.svgProps"
    ></SvgSelect>
  </div>
</template>

<script>
import { isObject } from 'lodash-es'

import SvgSelect from '@/js/components/Shared/SvgSelect/SvgSelect.vue'
import { mapGetters } from 'vuex'
import { types as STOREMODULES } from '@/js/plugins/store/store-modules.js'
import APP_GETTER from '@/js/plugins/store/modules/app/getter-types.js'

const CONSTANTS = {
  BACKGROUND: 'background',
  STRIPES_BOTTOM_RIGHT: 'stripesBottomRight',
  X_MID_Y_MAX: 'xMidYMax',
  X_MID_Y_MID: 'xMidYMid',
  MEET: 'meet',
  SLICE: 'slice',
}

export default {
  name: 'BackgroundElement',
  components: {
    SvgSelect,
  },
  props: {
    backgroundClasses: {
      type: [Object, String],
      default: () => ({}),
    },
    image: {
      type: String,
      required: true,
    },
    height: {
      type: String,
      default: '100%',
    },
  },
  computed: {
    ...mapGetters(STOREMODULES.APP, {
      isSmWidth: APP_GETTER.IS_SM_WIDTH,
    }),
    hasValidImage() {
      return ['stripesTopLeft', 'stripesBottomRight', 'stripesTopLeftTransparent'].includes(
        this.image,
      )
    },
    classes() {
      return Object.values(isObject(this.backgroundClasses) ? this.backgroundClasses : {}).reduce(
        (acc, value) => [...acc, value && `${CONSTANTS.BACKGROUND}--${value}`],
        [],
      )
    },
    aspectRatio() {
      return this.image === CONSTANTS.STRIPES_BOTTOM_RIGHT
        ? `${CONSTANTS.X_MID_Y_MAX} ${CONSTANTS.MEET}`
        : `${CONSTANTS.X_MID_Y_MID} ${CONSTANTS.SLICE}`
    },
    dimensions() {
      if (this.image === CONSTANTS.STRIPES_BOTTOM_RIGHT) {
        return this.stripesButtomRightDimension
      } else {
        return this.stripesDefaultDimension
      }
    },
    stripesButtomRightDimension() {
      return {
        svgProps: {
          width: 480,
          height: 480,
        },
        width: 320,
        height: 320,
      }
    },
    stripesDefaultDimension() {
      return {
        svgProps: {
          width: 480,
          height: 1440,
        },
        width: '100%',
        height: '100%',
      }
    },
  },
}
</script>

<style lang="scss" module>
.background {
  @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
    position: absolute;
  }
  // position: absolute;
  position: fixed;
  top: 0;
  left: 0;

  display: flex;

  width: 100%;
  height: 100%;
  max-height: 100%;
}

:global(.background--full-width) {
  right: 50%;
  left: 50%;

  width: 100vw;
  margin-right: -50vw;
  margin-left: -50vw;
}

:global(.background--right) {
  top: unset;
  bottom: 0;

  align-items: flex-end;

  justify-content: flex-end;
}

:global(.background--blue) {
  background: linear-gradient(180deg, rgb(111, 136, 154) 0%, rgb(198, 227, 233) 100%);
}

:global(.background--grey) {
  background: linear-gradient(180deg, rgba(195, 208, 216, 1) 0%, rgba(255, 255, 255, 1) 100%);
}

:global(.content--zIndex) {
  position: relative;
  z-index: 1;
}
</style>
